import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  size: PropTypes.oneOf(['large', 'small']).isRequired
};
const defaultProps = {
  size: 'large'
};

const Spinner = ({ size }) => (
  <div className="rec-nested-wrap">
    <div className="rec-grid-12-12">
      <div className="loading-wrap-sg-only">
        <div className="rec-loader-container">
          <div className={`rec-loader-${size}`}>
            <span className="rec-sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;

export default Spinner;
